import React, { useEffect, useState } from "react";

const GlobalErrorBanner = () => {
  const [errorMessage, setErrorMessage] = useState("");
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handler = (event) => {
      setErrorMessage(event.detail);
      setVisible(true);
    };

    window.addEventListener("GLOBAL_ERROR", handler);

    return () => {
      window.removeEventListener("GLOBAL_ERROR", handler);
    };
  }, []);

  if (!errorMessage) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: visible ? "10px" : "-80px", // slide animation
        left: "50%",
        transform: "translateX(-50%)",
        background: "#ff4d4f",
        color: "#fff",
        padding: "12px 50px 12px 18px",
        borderRadius: "8px",
        boxShadow: "0px 4px 12px rgba(0,0,0,0.2)",
        zIndex: 9999,
        fontSize: "15px",
        fontWeight: 600,
        minWidth: "260px",
        maxWidth: "90%",
        transition: "top 0.4s ease-in-out"
      }}
    >
      {/* Close button */}
      <span
        onClick={() => {
          setVisible(false);
          setTimeout(() => setErrorMessage(""), 400); // remove after animation
        }}
        style={{
          position: "absolute",
          right: "12px",
          top: "8px",
          cursor: "pointer",
          fontSize: "18px",
          fontWeight: "bold"
        }}
      >
        ✖
      </span>

      {errorMessage}
    </div>
  );
};

export default GlobalErrorBanner;
